import React, { useEffect, useState } from 'react';
import { Gift, Copy, Check, Users } from 'lucide-react';
import { toast } from 'sonner';
import api from '../api';

export default function ReferralCard() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get('/referrals/me').then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data?.code) return null;

  const link = `${window.location.origin}/auth?ref=${data.code}`;
  const copy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    toast.success('Referral link copied');
    setTimeout(() => setCopied(false), 1800);
  };
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: 'Purrflect', text: `Join me on Purrflect — AI vet help for your cat. Use my link for free PRO:`, url: link }); } catch (_) {}
    } else { copy(); }
  };

  return (
    <div className="mt-5 overflow-hidden rounded-3xl bg-white card-soft" data-testid="referral-card">
      <div className="flex items-center gap-2 bg-[hsl(var(--coral))] px-5 py-4 text-white">
        <Gift className="h-5 w-5" /><span className="font-extrabold">Refer a friend, both get PRO</span>
      </div>
      <div className="px-5 py-4">
        <p className="text-sm text-muted-foreground">Share your link. When a friend signs up, you <b>both</b> get {data.reward_days} days of Purrflect PRO free.</p>
        <div className="mt-3 flex items-center gap-2">
          <div className="flex-1 truncate rounded-xl border border-border bg-secondary px-3 py-2.5 text-sm font-semibold" data-testid="referral-link">{link}</div>
          <button onClick={copy} data-testid="referral-copy" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-border bg-white hover:bg-accent">
            {copied ? <Check className="h-4 w-4 text-[hsl(var(--coral))]" /> : <Copy className="h-4 w-4" />}
          </button>
        </div>
        <div className="mt-3 flex items-center justify-between">
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-muted-foreground"><Users className="h-4 w-4" /> {data.count} friend{data.count === 1 ? '' : 's'} joined</span>
          <button onClick={share} className="coral-btn rounded-full px-5 py-2 text-sm font-bold text-white">Share link</button>
        </div>
      </div>
    </div>
  );
}
